import { BarebonesReveal } from "@/components/skins/barebones/BarebonesReveal"
import type { ProductStorySection } from "@/lib/helpers/build-product-story-sections"

export const BarebonesProductStory = ({
  sections,
}: {
  sections: ProductStorySection[]
}) => {
  if (!sections.length) return null

  return (
    <div className="bb-pdp-story mt-16 w-full border-t border-[#e4ddd2]">
      {sections.map((section) => (
        <section
          key={section.key}
          className="bb-pdp-story-row grid w-full lg:grid-cols-2"
        >
          <BarebonesReveal
            from={section.imageLeft ? "left" : "up"}
            className={section.imageLeft ? "lg:order-1" : "lg:order-2"}
          >
            <div className="aspect-[5/4] w-full overflow-hidden bg-[#ece8e2] lg:aspect-auto lg:min-h-[520px]">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={section.imageUrl}
                alt=""
                className="h-full w-full object-cover"
              />
            </div>
          </BarebonesReveal>
          <BarebonesReveal
            from="up"
            delay={80}
            className={`flex items-center justify-center bg-[#f7f4ef] px-8 py-16 lg:px-16 ${
              section.imageLeft ? "lg:order-2" : "lg:order-1"
            }`}
          >
            <div className="max-w-md text-center">
              <p className="text-[12px] font-medium uppercase tracking-[0.22em] text-[#2b2118]">
                {section.eyebrow}
              </p>
              <span className="mx-auto mt-4 block h-px w-10 bg-[#2b2118]/35" />
              <p className="mt-6 text-[15px] leading-relaxed text-[#5c5148]">
                {section.body}
              </p>
            </div>
          </BarebonesReveal>
        </section>
      ))}
    </div>
  )
}
